import React, { useEffect } from 'react';

export default function Experience() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  useEffect(() => {
    scrollToTop()
  }, [])
  return (
    <><h2 className="text-4xl md:text-4xl text-center uppercase font-bold font-Kalam text-gray-800 pb-4 mt-10">
      <span class="underline underline-offset-3 decoration-3 decoration-black dark:decoration-black">Experience</span></h2>
      <div className="relative overflow-hidden bg-white ">
        <div className=" max-w-5xl mx-auto p-5 py-20" id="experience">


          {experiences.map((exp) => {
            return (
              <div className="w-full shadow-md p-5 rounded-lg mb-10 bg-gray-800">
                <div className=" grid md:grid-cols-4 gap-4 md:order-2">
                  <div
                    className="w-full h-20 flex items-center justify-center my-auto ease-in cursor-pointer"
                    onClick={() => window.open(exp.companyUrl || window.location, '_blank')}
                  >
                    <img
                      className="max-h-full max-w-full rounded-md bg-white duration-100 hover:scale-105"
                      src={exp.img ||
                        ''}
                      alt=""

                    ></img>
                  </div>
                  <div className="md:col-span-3 space-y-4 my-auto">
                    <div className="text-lg md:text-2xl text-white">{exp.company}</div>
                    <div className="md:flex justify-between">
                      <div className="text-xl uppercase font-semibold text-white ">{exp.position}</div>
                      <div className=" text-white">{exp.date}</div>
                    </div>
                    <div className=" text-xl text-white mt-3">
                      {exp.details.map((detail) => (<p>{detail}</p>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div></>
  );
}
const experiences = [
  {
    position: '   Junior Full Stack Developer. ',
    company: 'Logimax Technologies (P) Limited.',
    details: [
      'Full Stack Developer of ReactJS , Python (Django) , Tailwind (Flowbite) and MySQL .'
    ],
    date: 'Feb 2023 - Present',
    img: "https://firebasestorage.googleapis.com/v0/b/databaseserver-ca79e.appspot.com/o/react-portfolio-assets%2Flmx.png?alt=media&token=59fde88c-2272-44ae-80de-a694c22230c0",
    companyUrl: "https://www.logimaxindia.com/"

  },


  {
    position: 'Intern. ',
    company: 'Code Bind Technologies, Chennai.',
    details: [
      'Hands on training on scripting languages like HTML,CSS,PHP and MySQL.'
    ],
    date: 'Aug 2021 - Sept 2021',
    img: "https://firebasestorage.googleapis.com/v0/b/databaseserver-ca79e.appspot.com/o/react-portfolio-assets%2Fcodebind.png?alt=media&token=01c29c65-3b72-4ac5-acf0-af1f1bc812d0",
    companyUrl: "https://codebindtechnologies.com/"

  },

];